import 'app.css'
import 'devexpress-reporting/dx-webdocumentviewer'
import ko from 'knockout'
import React from 'react'

var docURL: any = '',
  docHost: any = '',
  docExportFormat: any = []

export const accountxReportUrl =
  process.env.REACT_APP_LOCAL_DB === 'staging'
    ? 'https://accountxuatreporting.ifca.asia'
    : process.env.REACT_APP_LOCAL_DB === 'training'
    ? 'http://accountxreporting-training.accountx.asia/'
    : process.env.REACT_APP_LOCAL_DB === 'noble'
    ? 'https://accountx-reporting.hotelxnobleresorthotelmelaka.com'
    : process.env.REACT_APP_LOCAL_DB === 'nobleuat'
    ? 'https://accountx-uat-reporting.hotelxnobleresorthotelmelaka.com'
    : process.env.REACT_APP_LOCAL_DB === 'asia'
    ? 'https://accountx-reporting.hotelxasiamelakahotel.com'
    : process.env.REACT_APP_LOCAL_DB === 'asiauat'
    ? 'https://accountx-uat-reporting.hotelxasiamelakahotel.com'
    : process.env.REACT_APP_LOCAL_DB === 'prod'
    ? 'https://accountxreporting.accountx.asia'
    : process.env.REACT_APP_LOCAL_DB === 'promenadeuat'
    ? 'https://accountxreporting-promenade-uat.accountx.asia'
    : process.env.REACT_APP_LOCAL_DB === 'promenade'
    ? 'https://accountxreporting-promenade.accountx.asia'
    : process.env.REACT_APP_LOCAL_DB === 'axifcadev'
    ? 'https://accountxdevinternalreporting.ifca.asia'
    : process.env.REACT_APP_LOCAL_DB === 'trial-migration'
    ? 'https://accountxreporting-trial-migration.accountx.asia'
    : process.env.REACT_APP_LOCAL_DB === 'ent-uat'
    ? 'https://accountxuat-ent-reporting.ifca.asia'
    : process.env.REACT_APP_LOCAL_DB === 'ent-train'
    ? 'https://accountxreporting-training-ent.accountx.asia'
    : process.env.REACT_APP_LOCAL_DB === 'prod-ent'
    ? 'https://accountxreporting-ent.accountx.asia'
    : process.env.REACT_APP_LOCAL_DB === 'prod-ent2'
    ? 'https://accountxreporting-ent2.accountx.asia'
    : process.env.REACT_APP_LOCAL_DB === 'prod-ax-px'
    ? 'https://accountxreporting-px.accountx.asia'
    : process.env.REACT_APP_LOCAL_DB === 'internal'
    ? 'https://accountxreporting-internal.accountx.asia'
    : 'https://accountxdevreporting.ifca.asia'

// export const menuxReportUrl = // 'http://localhost:61094'
// 	process.env.REACT_APP_ENV === 'dev'
// 		? 'https://menuxdevreporting.ifca.asia/'
// 		: process.env.REACT_APP_ENV === 'uat'
// 		? 'https://menuxuatreporting.ifca.asia/'
// 		: process.env.REACT_APP_ENV === 'prod'
// 		? 'https://menuxreporting.menux.asia/'
// 		: 'https://menuxdevreporting.ifca.asia/';

var docURL: any = '',
  docHost: any = '',
  docExportFormat: any = []

class RenderReportViewer extends React.Component {
  reportUrl: ko.Observable<any>
  previewModel: ko.Observable<any>
  requestOptions: {
    host: string
    invokeAction: string
  }
  callbacks: any | any
  viewer: any
  refs: any

  constructor(props) {
    super(props)

    this.reportUrl = ko.observable()
    this.previewModel = ko.observable()
    this.requestOptions = {
      host: docHost,
      invokeAction: '/WebDocumentViewer/Invoke',
    }

    this.previewModel.subscribe(function(newModel) {
      if (newModel) newModel.reportPreview.zoom(-1)
    })

    this.callbacks = {
      CustomizeParameterEditors: function(s, e) {
        if (e.parameter.type === 'System.DateTime') {
          e.info.editor = e.info.editor
          e.info.editor.extendedOptions =
            (e.info.editor.extendedOptions || {},
            {
              type: 'date',
              displayFormat: 'dd/MM/yyyy',
              useMaskBehavior: true,
            })
        }
      },
    }

    if (docExportFormat.length > 0) {
      this.callbacks = {
        CustomizeExportOptions: function(s, e) {
          docExportFormat.forEach(doc => {
            e.HideFormat(doc)
          })
        },
      }
    }
  }

  getReport() {
    this.previewModel().OpenReport(docURL)
  }

  render() {
    return (
      <div>
        <div>
          <div
            ref="viewer"
            data-bind="dxReportViewer: $data"
            style={{ width: '100%', height: '900px' }}
          ></div>
        </div>
      </div>
    )
  }
  componentDidMount() {
    ko.applyBindings(
      {
        reportUrl: this.reportUrl,
        viewerModel: this.previewModel,
        requestOptions: this.requestOptions,
        callbacks: this.callbacks,
      },
      this.refs.viewer
    )

    this.getReport()
  }
  componentWillUnmount() {
    ko.cleanNode(this.refs.viewer)
  }
}

function ReportViewer(props: any) {
  docURL = props.url
  docHost = props.host
  docExportFormat = props.excludedExportFormat
  return (
    <>
      <RenderReportViewer />
    </>
  )
}

export default ReportViewer
